const enum MenuVoActionType {
  SET_MENU_VO_LIST = 'SET_MENU_VO_LIST',
  SET_MENU_VO_CATEGORIES = 'SET_MENU_VO_CATEGORIES',
  SET_MENU_VO_WEBITEMVOS = 'SET_MENU_VO_WEBITEMVOS',
  SET_MENU_VO_ATTRIBUTEMAP = 'SET_MENU_VO_ATTRIBUTEMAP',
}

export { MenuVoActionType };
